module.exports = __webpack_public_path__ + "static/img/service_introduce_TH01_zh_h5.581a617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_TH01_zh_h5.png
// module id = SLoZ
// module chunks = 34